import { DOCUMENT, inject, Injectable } from '@angular/core';

import { EnvironmentService } from 'src/services/environment/environment.service';

@Injectable({ providedIn: 'root' })
export class BrowserConnectionService {
    private readonly document = inject<Document>(DOCUMENT);
    private readonly environmentService = inject(EnvironmentService);

    public init(): void {
        const environment = this.environmentService.environment;

        this.insertDnsPreFetchTags(environment.resourcesForDnsPreFetch);
        this.insertPreConnectTags(environment.resourcesForPreConnect);
    }

    private insertPreConnectTags(resources: string[]): void {
        resources.reverse().forEach((resource) => {
            const isNotInserted = this.document.querySelector(`link[rel="preconnect"][href="${resource}"]`) === null;

            if (isNotInserted) {
                const element = this.document.createElement('link');

                element.rel = 'preconnect';
                element.href = resource;
                element.setAttribute('crossorigin', '');
                this.insertToTopOfHead(element);
            }
        });
    }

    private insertDnsPreFetchTags(resources: string[]): void {
        resources.reverse().forEach((resource) => {
            const isNotInserted = this.document.querySelector(`link[rel="dns-prefetch"][href="${resource}"]`) === null;

            if (isNotInserted) {
                const element = this.document.createElement('link');

                element.rel = 'dns-prefetch';
                element.href = resource;
                this.insertToTopOfHead(element);
            }
        });
    }

    private insertToTopOfHead(element: HTMLElement): void {
        const head = this.document.getElementsByTagName('head')[0];
        head.insertBefore(element, head.firstChild);
    }
}
